// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — goose.styled.classic.js, новая — goose.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './goose.styled.classic';
import * as cp from './goose.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const OpenGateButton = isCp ? cp.OpenGateButton : classic.OpenGateButton;
export const StyledControlPanel = isCp ? cp.StyledControlPanel : classic.StyledControlPanel;
